/**
 * Reads the S3 key an asset URL points at, dropping origin, signature and
 * hash — the one part of the URL that stays the same across re-signing.
 *
 * @param url - Asset URL, signed or bare.
 * @returns The key, or the input unchanged when it is not a URL.
 */
export const getKeyFromUrl = (url: string): string => {
  try {
    return new URL(url).pathname.replace(/^\/+/, '');
  } catch {
    return url;
  }
};
